<template>
  <fieldset class="custom-checkbox" :class="[
    `${name}-group`,
    {'mandatory': mandatory},
    vflowGetFeedbackClasses('model_', 'checked')
  ]">
    <b-form-checkbox
      @change="$v['model_'].$touch(); vflowInputFocused('model_');"
      @click="$v['model_'].$touch(); vflowInputFocused('model_');"
      @input="$v['model_'].$touch(); vflowInputFocused('model_');"
      :name="name"
      :id="name"
      :required="mandatory"
      v-model="model_"
    >
      <slot name="txt">Lorem ipsum dolor sit amet consectetur adipisicing elit. Consectetur fugiat reiciendis accusamus suscipit deserunt quae, reprehenderit, expedita, laudantium necessitatibus vitae iure porro. Accusantium unde commodi accusamus ipsum natus. Inventore, tenetur in eius dolor numquam illum similique praesentium ratione quisquam iure hic quo neque tempore modi omnis facilis? Dolorum, est reprehenderit!</slot>
      <b-form-invalid-feedback><slot name="txtInvalidRequired">Lorem ipsum dolor sit amet.</slot></b-form-invalid-feedback>
    </b-form-checkbox>
  </fieldset>
</template>
<script>

import syncProperty from '@/mixins/syncProperty'
import validationFlow from '@/mixins/validators/validationFlow'
import { validationMixin } from 'vuelidate'

export default {
  name: 'LabeledCheckbox',
  mixins: [
    validationMixin,
    validationFlow,
    syncProperty('model', 'model_')
  ],
  data () {
    return {
    }
  },
  watch: {
    '$v.$invalid': {
      immediate: true,
      handler: function (newValue) {
        this.$emit('update:invalid', newValue)
      }
    }
  },
  props: {
    name: {
      type: String,
      required: true
    },
    mandatory: {
      type: Boolean,
      default: false
    },
    validation: {
      type: Object
    }
  },
  methods: { },
  computed: { },
  validations () {
    if (this.validation) {
      return {
        model_: this.validation
      }
    }
    return {
      model_: {
        checked (v) { return !this.mandatory || v }
      }
    }
  }
}
</script>
